import { computed, ref } from 'vue'

import type { GuestCountState } from '~/utils/GuestCountState'
import { readGuestCount } from '~/utils/readGuestCount'

const draftText = (raw: unknown): string => {
  const count = readGuestCount(raw)
  return count.provided ? String(count.value) : ''
}

/** The party size being typed at an entry point; it stays text until `attempt` reads it. */
export function useGuestCountDraft(initial: unknown = null) {
  const input = ref(draftText(initial))
  const attempted = ref(false)
  const count = computed<GuestCountState>(() => readGuestCount(input.value))
  const hasError = computed(() => attempted.value && !count.value.provided)

  /** Marks the draft as submitted, so an invalid value shows its error, and returns what it reads as. */
  const attempt = (): GuestCountState => {
    attempted.value = true
    return count.value
  }

  /** Replaces the draft with a stored party size and clears any shown error. */
  const reset = (raw: unknown): void => {
    input.value = draftText(raw)
    attempted.value = false
  }

  return { attempt, count, hasError, input, reset }
}
